import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_EDIT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_EDIT_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_IDENTIFICATION_IMAGE_EDIT_API_ID,
  ({ userId, identificationImageId, payload }) => ({
    endpoint: `/api/admin/users/${userId}identification-images/${identificationImageId}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
